import { C4Form } from './../c4-form';
import { Component, EventEmitter, Input, Output, Optional, Host } from '@angular/core';
import { C4InputFloat } from '../float/c4-input-float';
import { C4InputInterface, C4Input, C4InputConfig, C4Option } from '../c4-input';

@Component({
  selector: 'c4-input-integer',
  templateUrl: 'c4-input-integer.html',
  styles: [`
		.control-label {
			font-weight: normal;
		}
	`],
})
export class C4InputInteger extends C4Input implements C4InputInterface {
  @Input() config;
  @Input() name: string;
  @Input() tagId: string;
  @Input() value: number;

  @Output() valueChange: EventEmitter<number> = new EventEmitter<number>();

  @Input() precision: number;
  @Input() increment: number;
  @Input() stepCount: number;
  @Input() min: number;
  @Input() max: number;
  @Input() prefix: string;
  @Input() suffix: string;
  @Input() readonly: boolean;

  sensibleDefaults = {
    precision: 0,
    increment: 1
  }

  constructor( @Optional() @Host() form: C4Form) {
    super(form);
  }

  ngOnInit() {
    super.ngOnInit();
    this.precision = 0;
  }

  init(model: C4Option, config: C4InputConfig) {
    super.init(model, config);

    this.precision = this.sensibleDefaults.precision;
    this.increment = this.sensibleDefaults.increment;
    this.min = model.low;
    this.max = model.high;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/ui/src/app/directives/input/integer/c4-input-integer.ts